function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(750 8006)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.339,17.289c-1.083,1.66-2.2,3.311-3.972,3.345-1.741.035-2.3-1.081-4.285-1.081S8.472,20.6,6.828,20.669c-1.707.067-3.006-1.793-4.1-3.446C.5,13.843-1.2,7.666,1.087,3.5A6.316,6.316,0,0,1,6.455.084C8.131.051,9.716,1.269,10.74,1.269S13.688-.193,15.709.021a5.971,5.971,0,0,1,4.746,2.7,6.2,6.2,0,0,0-2.8,5.188,5.974,5.974,0,0,0,3.483,5.508A15.337,15.337,0,0,1,19.339,17.289Z",
  transform: "translate(-750 -7999.433)",
  fill: "#ffffff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.411,2.063A5.741,5.741,0,0,1,5.234,0,6.2,6.2,0,0,1,3.882,4.35,4.728,4.728,0,0,1,.033,6.278,5.879,5.879,0,0,1,1.411,2.063Z",
  transform: "translate(-739.498 -8006)",
  fill: "#ffffff"
}));

function SvgApplestoreBanner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.137,
    height: 27.238,
    viewBox: "0 0 21.137 27.238",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplestoreBanner);
export default __webpack_public_path__ + "static/media/ApplestoreBanner.446058a3.svg";
export { ForwardRef as ReactComponent };